export default function FeuilleRouteConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('feuille.route');
}

FeuilleRouteConfiguration.$inject = ['$translatePartialLoaderProvider'];
